<template>
    <sa-page-layout ref="SaplPostiLettoPianiList" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <b-form-select v-model="filtroConfigurazionePostiLetto.denominazioneStruttura" type="search" id="denominazioneStruttura" placeholder="Inserire Nome Struttura" :options="nomeStrutturaOptions" @change="onChangeStruttura">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Struttura - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio</label>
                        <b-form-select v-model="filtroConfigurazionePostiLetto.denominazionePresidio" type="search" id="denominazionePresidio" placeholder="Inserire Nome Presidio" :options="nomePresidioOptions" @change="onChangePresidio">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Presidio - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Piano</label>
                        <b-form-select v-model="filtroConfigurazionePostiLetto.nome" type="search" id="Piano" placeholder="Inserire piano" :options="nomePianoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Piano - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <ras-configurazione-posti-letto-piani-list-component ref="RasConfigurazionePostiLettoPianiListComponent" @errorRestCall="onError" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" @updateFilter="onUpdateFilter"></ras-configurazione-posti-letto-piani-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RasConfigurazionePostiLettoPianiListComponent from "../components/RasConfigurazionePostiLettoPianiListComponent.vue";
export default {
    components: { SaPageLayout, RasConfigurazionePostiLettoPianiListComponent },
    data() {
        return {
            btnConfigurazioniVisible: true,
            filtroConfigurazionePostiLetto: { denominazioneStruttura: null, denominazionePresidio: null, nome: null },
            btnNewVisible: true,
            pathResource: "/rsapostilettopiani",
            pathResourceStrutture: "/strutture",
            pathResourcePresidi: "/strutturepresidi",
            pathResourcePiani: "/rsapostilettopiani",
            linkedit: "/rsaconfigurazionepostilettopiani",
            linkConfigurazioni: "/configurazioni",
            showModalLoading: false,
            listKey: 0,
            nomeStrutturaOptions: [],
            nomePresidioOptions: [],
            nomePianoOptions: [],
            filtroPresidi: { idStruttura: null },
            filtroPiani: { idPresidio: null },
        };
    },
    mounted() {
        let me = this;
        //me.filtroConfigurazionePostiLetto = { denominazioneStruttura: null, denominazionePresidio: null, nome: null };
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazionePostiLetto"]) {
            let filtro = JSON.parse(sessionStorage["filtroConfigurazionePostiLetto"]);
            if (Object.keys(filtro).length === 0) {
                filtro = {
                    denominazioneStruttura: null,
                    denominazionePresidio: null,
                    nome: null,
                };
            }
            me.filtroConfigurazionePostiLetto = filtro;
        }

        me.loadDataStrutture();
        //me.loadDataPresidi();
        //me.loadDataPiani();
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RasConfigurazionePostiLettoPianiListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onReset() {
            let me = this;
            me.filtroConfigurazionePostiLetto = { denominazioneStruttura: null, denominazionePresidio: null, nome: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazionePostiLetto"] = JSON.stringify(me.filtroConfigurazionePostiLetto);
            //console.log("Prova nome Presidio", me.nomePresidioOptions);
            me.nomePresidioOptions = [];
            me.nomePianoOptions = [];
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazionePostiLetto"] = JSON.stringify(me.filtroConfigurazionePostiLetto);
            me.loadData();
        },
        onError(errorData) {
            let me = this;
            me.$refs.SaplPostiLettoPianiList.showModalError(errorData);
        },
        onUpdateFilter(filterData) {
            this.filtroConfigurazionePostiLetto = filterData;
            // console.log("filtroConfigurazionePostiLetto", filterData);
        },
        loadDataStrutture() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStrutture, {}, me.loadDataStruttureSuccess, me.loadDataStruttureError);
        },
        loadDataStruttureSuccess(response) {
            let me = this;
            if (response.data.data) {
                me.nomeStrutturaOptions = response.data.data.map((item) => {
                    return { value: item.denominazione, text: item.denominazione, id: item.id };
                });
            } else {
                me.nomeStrutturaOptions = [];
            }
            if (me.filtroConfigurazionePostiLetto.denominazioneStruttura) {
                let strutturafiltrata = me.nomeStrutturaOptions.find((item) => item.value === me.filtroConfigurazionePostiLetto.denominazioneStruttura);
                if (strutturafiltrata) {
                    me.filtroPresidi = { idStruttura: strutturafiltrata.id };
                    me.loadDataPresidi();
                }
            }
        },
        loadDataStruttureError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle strutture", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPresidi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, me.filtroPresidi, me.loadDataPresidiSuccess, me.loadDataPresidiError);
        },
        loadDataPresidiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.nomePresidioOptions = response.data.data.list.map((item) => {
                    return { value: item.denominazione, text: item.denominazione, id: item.id };
                });
            } else {
                me.nomePresidioOptions = [];
            }
            if (me.filtroConfigurazionePostiLetto.denominazionePresidio) {
                let presidioFiltrato = me.nomePresidioOptions.find((item) => item.value === me.filtroConfigurazionePostiLetto.denominazionePresidio);
                if (presidioFiltrato) {
                    me.filtroPiani = { idPresidio: presidioFiltrato.id };
                    me.loadDataPiani();
                }
            }
        },
        loadDataPresidiError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei presidi", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPiani() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroPiani, me.loadDataPianiSuccess, me.loadDataPianiError);
        },
        loadDataPianiSuccess(response) {
            let me = this;
            //console.log("LISTA PIANI:", response.data.data.list);
            if (response.data.data.list) {
                me.nomePianoOptions = response.data.data.list.map((item) => {
                    return { value: item.nome, text: item.nome, id: item.id };
                });
            } else {
                me.nomePianoOptions = [];
            }
        },
        loadDataPianiError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei piani", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onChangeStruttura(nome) {
            let me = this;
            let selectedStruttura = me.nomeStrutturaOptions.find((item) => item.value === nome);
            //console.log("Struttura selezionata:", selectedStruttura);
            me.nomePresidioOptions = [];
            me.nomePianoOptions = [];
            me.filtroConfigurazionePostiLetto.denominazionePresidio = null;
            me.filtroConfigurazionePostiLetto.nome = null;
            if (selectedStruttura) {
                me.filtroPresidi = { idStruttura: selectedStruttura.id };
                me.loadDataPresidi();
            }
        },
        onChangePresidio(nome) {
            let me = this;
            let selectedPresidio = me.nomePresidioOptions.find((item) => item.value === nome);
            me.filtroConfigurazionePostiLetto.nome = null;
            //console.log("Presidio selezionato:", selectedPresidio);
            me.nomePianoOptions = [];
            if (selectedPresidio) {
                me.filtroPiani = { idPresidio: selectedPresidio.id };
                me.loadDataPiani();
            }
        },
    },
};
</script>

<style></style>
